// #803 — a `{ $in: [...] }` REST query serialises to indexed params and the backend's `qs.parse`
// caps arrays at 20 (`arrayLimit`): the 22nd id arrives as an OBJECT (`{ '21': id }`) and the find
// 500s with "Cast to ObjectId failed". A `$in` FETCH of many ids must be split into <=20-id batches.
// (Client-side `selectByQuery` over the store is unaffected: the cap is purely a query-string quirk.)
export const IN_CHUNK = 20;

export function chunkIds<T>(ids: ReadonlyArray<T>): T[][] {
    const out: T[][] = [];
    for (let i = 0; i < ids.length; i += IN_CHUNK) out.push(ids.slice(i, i + IN_CHUNK));
    return out;
}

/**
 * For a paged server find that CANNOT be batched (`$skip` paging), drop any top-level `$in` array
 * longer than IN_CHUNK from the query that goes to the server. The server then returns a superset
 * and the caller's client-side selector (which still has the full `$in`) does the exact filtering.
 * Queries within the cap are returned unchanged.
 */
export function withoutOversizedIn<Q extends Record<string, unknown>>(query: Q): Q {
    let out: Record<string, unknown> | undefined;
    for (const [key, value] of Object.entries(query)) {
        const arr = value && typeof value === 'object' ? (value as { $in?: unknown }).$in : undefined;
        if (Array.isArray(arr) && arr.length > IN_CHUNK) {
            out ??= { ...query };
            delete out[key];
        }
    }
    return (out ?? query) as Q;
}
